export default function showHiddenElement(selector) {
  const hiddenElem = document.querySelector(selector);
  if (hiddenElem) {
    hiddenElem.classList.remove("vue-hidden");
    hiddenElem.classList.add("vue-ready");
  }
}
